import React from "react";
import {withRouter} from "../../utils/tms-with-router/tms-with-router";
const TmsCalender = () => {
  return <div>Hello, Welcome to Calender</div>;
};
export default withRouter(TmsCalender);
